// src/components/ResponsiveNavbar.js
import './ResponsiveNavbar.scss';
import { useRef, useState, useEffect } from 'react';
import stampLogo from '../../images/cs_white_trim.png'; // Make sure this is the correct logo
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faLanguage } from '@fortawesome/free-solid-svg-icons'; // Combined imports
import { useRefs } from '../../context/RefContext';
import { Trans } from "@lingui/react/macro";
import LanguageSelector from '../../helpers/langselect.js';

const ResponsiveNavbar = () =>
{
    const [menuOpen, setMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [isCompanyOpen, setIsCompanyOpen] = useState(false);
    const menuRef = useRef(null);
    const navigate = useNavigate();
    const { indexRef, companyRef, visionRef, weRef, contactRef, handleScrollTo } = useRefs();
    
    const closeDropdown = () => {
        setIsCompanyOpen(false);
    };

    const handleMenuToggle = () =>
    {
        setMenuOpen(!menuOpen);
    };

    const handleLinkClick = (path, ref) =>
    {
        setMenuOpen(false);
        navigate(path);
        if (ref)
        {
            setTimeout(() =>
            {
                handleScrollTo(ref);
            }, 300);
        }
    };

    const handleScroll = () =>
    {
        if (window.scrollY > 50)
        {
            setIsScrolled(true);
        } else
        {
            setIsScrolled(false);
        }
    };

    useEffect(() =>
    {
        window.addEventListener('scroll', handleScroll);
        // Add a click listener to close menu when clicking outside
        document.addEventListener('mousedown', handleClickOutside);
        return () =>
        {
            window.removeEventListener('scroll', handleScroll);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target) && event.target.closest('.menu') === null) {
            setMenuOpen(false);
        }
    };

    return (
        <nav className={isScrolled ? 'scrolled' : ''}>
            <div className="nav_container">

                <Link to='/' onClick={() => handleLinkClick('/', indexRef)}>
                    <img src={stampLogo} alt="logo" className='logo' />
                </Link>
                <div className="menu" onClick={handleMenuToggle}>
                    <FontAwesomeIcon icon={faBars} />
                </div>
                <ul ref={menuRef} className={menuOpen ? "open" : ""}> {/* Removed open_sans from ul */}
                    <li>
                        <div 
                            className={`dropdown-company ${isCompanyOpen ? "force-open" : ""}`}
                            onMouseEnter={() => setIsCompanyOpen(true)}
                            onMouseLeave={() => setIsCompanyOpen(false)}
                        >
                            <button className="dropbtn">
                            <Link
                            to="/"
                            className='' 
                            onClick={() => {handleLinkClick('/', companyRef); closeDropdown();}}
                            >
                                <Trans>LA COMPAÑÍA</Trans>
                            </Link></button>
                        <div className="dropdown-content-company">
                            <div className="companydiv">
                            <Link
                            to="/"
                            className='companybutton' 
                            onClick={() => {handleLinkClick('/', weRef); closeDropdown();}}>
                                <Trans>EL EQUIPO</Trans>
                            </Link>
                            <Link
                            to="/"
                            className='companybutton'
                            onClick={() => {handleLinkClick('/', visionRef); closeDropdown();}}>
                                <Trans>VISIÓN</Trans>
                            </Link>
                            </div>
                        </div>
                    </div>
                    </li>
                    {/*<li>
                        <Link
                            to="/"
                            className='' // Removed open_sans
                            onClick={() => handleLinkClick('/', visionRef)}
                        >
                            <Trans>MISIÓN</Trans>
                        </Link>
                    </li> */}
                    <li>
                        <Link
                            to="/desarrollos"
                            className='' 
                            onClick={() => handleLinkClick('/desarrollos', indexRef)}
                        >
                            <Trans>DESARROLLOS</Trans>
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/novedades"
                            className='' // Removed open_sans
                            onClick={() => handleLinkClick('/novedades', indexRef)}
                        >
                            <Trans>NOVEDADES</Trans>
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/"
                            className='' // Removed open_sans
                            onClick={() => handleLinkClick('/', contactRef)}
                        >
                            <Trans>CONTACTO</Trans>
                        </Link>
                    </li>
                    <div className="dropdown">
                        <button className="dropbtn"><FontAwesomeIcon style={{height: "22px"}} icon={faLanguage} /></button>
                        <div className="dropdown-content">
                            <LanguageSelector/>
                        </div>
                    </div>
                   <div className="langhor"><LanguageSelector/></div> {/* This div is for mobile only */}
                </ul>
            </div>
        </nav>
    );
};

export default ResponsiveNavbar;